module.exports = __webpack_public_path__ + "static/img/knowledgePlaceholder.5c1ebc1e.jpg";